exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#payment_form_submit{min-width:120px;display:inline-block}.timer{width:25px;height:25px;display:inline-block;border-width:2px !important;border-style:solid;line-height:1.3}", ""]);

// exports
